export default "__VITE_ASSET__CrwRYc$V__"